<template>
  <div class="student-awards" ref="studentAwards">
    <b-tooltip :position="tooltipPosition" type="is-white">
      <div class="awards-grid">
        <div
          v-for="award in studentAwards"
          :key="award.code"
          class="award-dot"
          :title="award.name"
        >
          <img
            :src="require(`@/assets/img/awards/${award.icon}`)"
            :alt="award.name"
            class="award-dot-icon"
          />
        </div>
      </div>

      <template v-slot:content>
        <div v-if="studentAwards.length === 0">Right click to add awards</div>
        <div v-else class="awards-tooltip">
          <div v-for="award in studentAwards" :key="award.code">
            <img
              :src="require(`@/assets/img/awards/${award.icon}`)"
              :alt="award.name"
              class=""
            />
            {{ award.name }}
          </div>
        </div>
      </template>
    </b-tooltip>
  </div>
</template>

<script>
import { getAwardsByCode } from "@/utils/award-helper";

export default {
  name: "RollAwardMini",

  props: {
    awards: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      tooltipPosition: "is-bottom",
    };
  },

  computed: {
    studentAwards() {
      return getAwardsByCode(this.awards);
    },
  },

  mounted() {
    this.updateTooltipPosition();
    // Listen for scroll events on the scrollable container
    this.scrollContainer = this.findScrollContainer();
    if (this.scrollContainer) {
      this.scrollContainer.addEventListener(
        "scroll",
        this.updateTooltipPosition
      );
    }
  },

  beforeDestroy() {
    if (this.scrollContainer) {
      this.scrollContainer.removeEventListener(
        "scroll",
        this.updateTooltipPosition
      );
    }
  },

  methods: {
    findScrollContainer() {
      let element = this.$el.parentElement;
      while (element) {
        const style = window.getComputedStyle(element);
        if (
          style.overflowY === "scroll" ||
          style.overflowY === "auto" ||
          element.classList.contains("attendance__body")
        ) {
          return element;
        }
        element = element.parentElement;
      }
      return null;
    },

    updateTooltipPosition() {
      if (!this.$refs.studentAwards || !this.scrollContainer) {
        return;
      }

      const elementRect = this.$refs.studentAwards.getBoundingClientRect();
      const containerRect = this.scrollContainer.getBoundingClientRect();

      // Calculate relative position within the container
      const relativeTop = elementRect.top - containerRect.top;
      const containerHeight = containerRect.height;

      // Determine position based on thirds of the container
      const topThird = containerHeight / 3;
      const bottomThird = (containerHeight * 2) / 3;

      if (relativeTop < topThird) {
        // Close to top - show tooltip below
        this.tooltipPosition = "is-bottom";
      } else if (relativeTop > bottomThird) {
        // Close to bottom - show tooltip above
        this.tooltipPosition = "is-top";
      } else {
        // In middle - show tooltip to the right
        this.tooltipPosition = "is-right";
      }
    },
  },
};
</script>

<style scoped>
.student-awards {
  display: flex;
  align-items: center;
  margin-left: 4px;
}

.awards-grid {
  display: grid;
  grid-template-columns: repeat(6, 8px);
  grid-template-rows: repeat(3, 8px);
  grid-auto-flow: column dense; /* Fill columns first, then rows */
  gap: 1px;
  min-width: 40px;
  height: 26px;
}

.award-dot {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.award-dot-icon {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  object-fit: contain;
  flex-shrink: 0;
}

.awards-tooltip {
  text-align: left;
  padding: 0.5rem 1rem 0 0;
}
</style>
